import React from 'react';

export const TrashIcon = ({ onClick }: { onClick: () => void }) => (
    <button onClick={onClick} className="p-1 hover:bg-red-100 rounded-full">
        <svg className="w-5 h-5 text-grayscale-900 hover:text-red-500" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" d="M9 2a1 1 0 00-.894.553L7.382 4H4a1 1 0 000 2v10a2 2 0 002 2h8a2 2 0 002-2V6a1 1 0 100-2h-3.382l-.724-1.447A1 1 0 0011 2H9zM7 8a1 1 0 011-1h4a1 1 0 110 2H8a1 1 0 01-1-1zm1 3a1 1 0 100 2h2a1 1 0 100-2H8z" clipRule="evenodd" />
        </svg>
    </button>
);